import React, { Component } from 'react';
import ModalBase from './ModalBase';
import EdbButton from './EdbButton';

class ModalConfirm extends Component {

    render() {
        return (<ModalBase  {...this.props} hideClose={true} content={
            <div className="edb-padding-large">
                <h3>{this.props.title || "Tem certeza?"}</h3>

                {this.props.content}

                <div className="edb-margin-large-top">
                    <button
                        className="edb-block-mobile edb-margin-bottom edb-margin-right edb-button adap-gray edb-round"
                        onClick={this.props.onClickCancel}
                        disabled={this.props.loadingConfirm}>
                        {this.props.cancelText || "Não"}
                    </button>

                    <EdbButton className="edb-block-mobile edb-margin-bottom adap-gray"
                        content={this.props.confirmText || "Sim"}
                        loadingContent={this.props.confirmLoadingText || "Aguarde..."}
                        loading={this.props.loadingConfirm}
                        onClick={this.props.onClickConfirm} />

                </div>
            </div>
        } />);
    }
}

export default ModalConfirm;